import type { AircraftEventAirport } from '#entities';

export const getAircraftLocationInfo = (
  airports: AircraftEventAirport[],
): AircraftEventAirport[] => {
  const now = Date.now();

  const result: AircraftEventAirport[] = [];
  const standByAirportIndex = airports.findIndex(a => a.distance < 10000);

  // Aircraft is on flight and next airport is arrival airport
  const arrivalAirportIndex = airports.findIndex(a => a.startUnix > now);

  if (arrivalAirportIndex > 0) {
    result.push(airports[arrivalAirportIndex]);
  }

  if (arrivalAirportIndex > 0) {
    if (standByAirportIndex >= 0) {
      result.unshift(airports[arrivalAirportIndex - 1]);
    } else {
      result.unshift(airports[arrivalAirportIndex - 1]);
    }
  }

  return result;
};
